import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { MEDAL_COLORS } from '../WorldCupLeaderboard/WorldCupLeaderboard.constants';
import {
  SQUAD_TV_STADIUM_COLORS,
  SQUAD_TV_STADIUM_ROW_HEIGHT,
} from '../../../src/worldcup/constants/squadTvMode.constants';

export const getSquadTvStandingRowStyles = (theme: Theme) =>
  StyleSheet.create({
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      height: SQUAD_TV_STADIUM_ROW_HEIGHT,
      paddingHorizontal: 40,
    },
    rowAlt: {
      backgroundColor: SQUAD_TV_STADIUM_COLORS.rowAlt,
    },
    rowMe: {
      backgroundColor: theme.cardActiveBg,
    },
    topAccent: {
      position: 'absolute',
      left: 0,
      top: 10,
      bottom: 10,
      width: 4,
      borderRadius: 2,
    },
    accentGold: { backgroundColor: MEDAL_COLORS.gold },
    accentSilver: { backgroundColor: MEDAL_COLORS.silver },
    accentBronze: { backgroundColor: MEDAL_COLORS.bronze },
    rankCell: {
      width: 64,
    },
    rankText: {
      fontSize: 21,
      fontWeight: '800',
      color: theme.gray[400],
      fontVariant: ['tabular-nums'],
    },
    rankGold: { color: MEDAL_COLORS.gold },
    rankSilver: { color: MEDAL_COLORS.silver },
    rankBronze: { color: MEDAL_COLORS.bronze },
    who: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 14,
      minWidth: 0,
    },
    name: {
      flex: 1,
      fontSize: 19,
      fontWeight: '600',
      color: theme.gray[800],
    },
    nameTop: {
      fontWeight: '700',
      color: theme.gray[900],
    },
    pts: {
      flexDirection: 'row',
      alignItems: 'baseline',
      justifyContent: 'flex-end',
      gap: 7,
      width: 150,
    },
    ptsValue: {
      fontSize: 23,
      fontWeight: '800',
      color: theme.accentDark,
      fontVariant: ['tabular-nums'],
    },
    ptsValueTop: {
      color: theme.accent,
    },
    ptsUnit: {
      fontSize: 12,
      fontWeight: '600',
      color: theme.gray[400],
    },
  });
